import guards from './get'
import multiguard from 'vue-router-multiguard';

function set(store, allGuards) {
  return guardName => allGuards[guardName] ? allGuards[guardName](store) : null
}

function applyGuards(store, allGuards) {
  return route => {
    // @todo handle nested routes
    let routeGuards = _.compact([...(route.guards || []).map(set(store, allGuards)), route.beforeEnter])
    route.beforeEnter = multiguard(routeGuards)
    return route
  }
}

function guard(routes, store, extraGuards = {}) {
  const allGuards = {
    ...guards,
    ...extraGuards
  }
  return routes.map(applyGuards(store, allGuards))
}

export default guard
